import { useMemo } from "react";
import {
  Bar, BarChart, CartesianGrid, Line, LineChart, Tooltip, XAxis, YAxis,
} from "recharts";
import { CockpitPanel } from "@/cockpit/CockpitPanel";
import { FixedChart } from "@/cockpit/FixedChart";
import { downsampleSeries } from "@/cockpit/downsample";
import { AXIS, GRID, PRICE, SENT, VOLUME, fmtMd, tooltipBox } from "@/cockpit/formatCockpit";

export function SentimentOscillatorChart({ series, onOpenRaw }) {
  const data = useMemo(() => downsampleSeries(series || [], 500), [series]);

  return (
    <CockpitPanel
      title="Sentiment oscillator"
      hint="Top: 7d score (−1 to +1). Bottom: mention volume. Dashed = close for divergence only."
      onOpenRaw={onOpenRaw}
      testid="sentiment-oscillator-chart"
    >
      <FixedChart height={180}>
        {(width) => (
          <LineChart width={width} height={180} data={data} syncId="talk-osc" onClick={onOpenRaw} margin={{ top: 8, right: 8, left: 0, bottom: 0 }}>
            <CartesianGrid stroke={GRID} strokeDasharray="3 3" vertical={false} />
            <XAxis dataKey="date" hide />
            <YAxis domain={[-1, 1]} tick={{ fill: AXIS, fontSize: 9 }} width={36} />
            <YAxis yAxisId="px" orientation="right" tick={{ fill: AXIS, fontSize: 9 }} width={40} />
            <Tooltip
              contentStyle={tooltipBox}
              formatter={(v, name) => {
                if (name === "sentimentScore") return [Number(v).toFixed(2), "Sentiment"];
                if (name === "stockPrice") return [`$${Number(v).toFixed(2)}`, "Close (overlay)"];
                return [v, name];
              }}
              labelFormatter={fmtMd}
            />
            <Line dataKey="sentimentScore" stroke={SENT} dot={false} strokeWidth={1.7} isAnimationActive={false} />
            <Line dataKey="stockPrice" yAxisId="px" stroke={PRICE} dot={false} strokeDasharray="4 4" strokeWidth={1} isAnimationActive={false} />
          </LineChart>
        )}
      </FixedChart>
      <div className="mt-1">
        <FixedChart height={100}>
          {(width) => (
            <BarChart width={width} height={100} data={data} syncId="talk-osc" onClick={onOpenRaw} margin={{ top: 4, right: 8, left: 0, bottom: 0 }}>
              <CartesianGrid stroke={GRID} strokeDasharray="3 3" vertical={false} />
              <XAxis dataKey="date" tick={{ fill: AXIS, fontSize: 9 }} tickFormatter={fmtMd} minTickGap={28} />
              <YAxis tick={{ fill: AXIS, fontSize: 9 }} width={36} />
              <Tooltip contentStyle={tooltipBox} formatter={(v) => [v, "Mentions"]} labelFormatter={fmtMd} />
              <Bar dataKey="mentionVolume" fill={VOLUME} maxBarSize={6} isAnimationActive={false} />
            </BarChart>
          )}
        </FixedChart>
      </div>
    </CockpitPanel>
  );
}
